// extracted by mini-css-extract-plugin
export default {"descriptionTextContainer":"ParagraphButton_descriptionTextContainer__XNFfB","paragraphButton":"ParagraphButton_paragraphButton__KdZ-C"};